<template>
  <div>
    <div :class="['sidebar', 'theme-base-bg-color', status, side]">
      <button class="sidebar-button close" @click="status = 'close'"><svg class="sidebar-svg theme-accent-fill-color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5 c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9 c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/></svg></button>
      <slot>Contents here</slot>
    </div>

    <button class="sidebar-button open" @click="status = 'open'"><svg class="sidebar-svg theme-accent-fill-color" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"><path d="M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,238.3,434.3,224,417.4,224z"/><path d="M417.4,96H94.6C77.7,96,64,110.3,64,128c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,110.3,434.3,96,417.4,96z"/><path d="M417.4,352H94.6C77.7,352,64,366.3,64,384c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32 C448,366.3,434.3,352,417.4,352z"/></svg></button>
  </div>
</template>

<script>
export default {
  name: 'mimic-amp-sidebar',
  components: {
  },
  props: ['side'],
  data: function () {
    return {
      status: 'close'
    }
  },
  methods: {
    close: function () {

    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.native {
  @import "../sidebar/SidebarStandard1/SidebarStandard1.scss";
}
.smartphone,
.tablet,
.desktop {
  @import "../sidebar/SidebarStandard1/SidebarStandard1.s.scss";
  .sidebar {
    width: 80% !important;
    position: absolute !important;
    &-button {
      position: absolute !important;
    }
  }
}
.tablet,
.desktop {
  @import "../sidebar/SidebarStandard1/SidebarStandard1.m.scss";
  .sidebar {
    width: 400px !important;
  }
}
.desktop {
  @import "../sidebar/SidebarStandard1/SidebarStandard1.l.scss";
}

.sidebar {
  position: fixed !important;
  max-height: 100vh !important;
  height: 100vh;
  max-width: 80vw !important;
  min-width: 45px !important;
  outline: none;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  z-index: 2147483647;
  -webkit-overflow-scrolling: touch;
  will-change: transform;
  transform: translateX(100%);
  transition: transform 233ms cubic-bezier(0,0,.21,1);
  &.top-left {
    top: 0;
    left: 0;
    transform: translateX(-100%);
  }
  &.top-right {
    top: 0;
    right: 0;
    transform: translateX(100%);
  }
  &.bottom-left {
    left: 0;
    bottom: 0;
    transform: translateX(-100%);
  }
  &.bottom-right {
    right: 0;
    bottom: 0;
    transform: translateX(100%);
  }
  &.open {
    transform: translateX(0) !important;
    transition: transform 233ms cubic-bezier(0,0,.21,1);
  }
}
</style>

<doc>
https://blog.madewithenvy.com/the-order-property-flexbox-carousels-87a168567820
</doc>


// WEBPACK FOOTER //
// src/components/mimic-amp/MimicAmpSidebar.vue